import * as React from 'react';

const SvgDualSimCard = (props) => (
  <svg
    width={32}
    height={32}
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.00002 1.69336C4.51695 1.69336 1.69336 4.51695 1.69336 8.00003V20C1.69336 23.4831 4.51695 26.3067 8.00003 26.3067H8.43043C8.9582 28.9281 11.274 30.9023 14.0509 30.9023H24.9334C28.0999 30.9023 30.6668 28.3354 30.6668 25.1689V15.9984C30.6668 14.5837 30.1437 13.2189 29.1982 12.1666L25.5463 8.10204C24.4589 6.89179 22.9085 6.20052 21.2815 6.20052H20.3928L18.3737 3.87023C17.1758 2.48766 15.4366 1.69336 13.6073 1.69336H8.00002ZM17.817 6.20052L16.9025 5.14496C16.0743 4.18916 14.872 3.64003 13.6073 3.64003H8.00002C5.59206 3.64003 3.64003 5.59206 3.64003 8.00003V20C3.64003 22.408 5.59206 24.36 8.00003 24.36H8.31755V11.9339C8.31755 8.76742 10.8844 6.20052 14.0509 6.20052H17.817ZM24.9334 28.9556H14.0509C11.9596 28.9556 10.2642 27.2603 10.2642 25.1689V11.9339C10.2642 9.84253 11.9596 8.14719 14.0509 8.14719H21.2815C22.3561 8.14719 23.3801 8.60374 24.0983 9.40308L27.7502 13.4676C28.3746 14.1626 28.7201 15.064 28.7201 15.9984V25.1689C28.7201 27.2603 27.0247 28.9556 24.9334 28.9556Z'
      fill='#E00034'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M22.9667 26.9551C22.3592 26.9551 21.8667 26.4626 21.8667 25.8551L21.8667 19.9884C21.8667 19.3809 22.3592 18.8884 22.9667 18.8884C23.5742 18.8884 24.0667 19.3809 24.0667 19.9884L24.0667 25.8551C24.0667 26.4626 23.5742 26.9551 22.9667 26.9551Z'
      fill='#E00034'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.2997 26.9551C18.6922 26.9551 18.1997 26.4626 18.1997 25.8551L18.1997 19.9884C18.1997 19.3809 18.6922 18.8884 19.2997 18.8884C19.9072 18.8884 20.3997 19.3809 20.3997 19.9884L20.3997 25.8551C20.3997 26.4626 19.9072 26.9551 19.2997 26.9551Z'
      fill='#E00034'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.6332 26.9551C15.0257 26.9551 14.5332 26.4626 14.5332 25.8551L14.5332 19.9884C14.5332 19.3809 15.0257 18.8884 15.6332 18.8884C16.2407'
    />
  </svg>
);

export default SvgDualSimCard;
